import { Component, OnInit, Input, OnChanges, ViewChild, SimpleChanges } from '@angular/core';
import { NovedadesPeriodo } from '../../../../models/novedadesPeriodo';
import { NovedadesPeriodoDetalleComponent } from '../novedades-periodo-detalle/novedades-periodo-detalle.component';
import { ErroresService } from '../../../../core/services/errores.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { NovedadesPeriodoService } from '../../../../services/novedades-periodo.service';
import { DialogConfirmacionComponent } from '../../../../components/shared/dialog-confirmacion/dialog-confirmacion.component';
import { DialogProcesandoComponent } from '../../../../components/shared/dialog-procesando/dialog-procesando.component';
import { IboxtoolsItem } from '../../../../models/iboxtools-item';
import { GruposLiquidacionService } from '../../../../services/gruposLiquidacion.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-novedades-periodo',
  templateUrl: './novedades-periodo.component.html',
  styleUrls: ['./novedades-periodo.component.css']
})
export class NovedadesPeriodoComponent implements OnInit, OnChanges {

  @Input() personalId;
  @Input() fechaslist;
  @Input() gruposLiquidaciones;
  disabledEditing: boolean;
  novedadPeriodo: NovedadesPeriodo;
  verDetalle: boolean = false;
  isEditing: boolean = false;
  permisoEdicion: boolean = false;
  habilitarFormDetalle: boolean = false;
  MensajeError: string;

  //Control ibox
  novedadesPeriodosHistoryList: any;
  novedadesPeriodosList: NovedadesPeriodo[];
  toolboxEnabled: boolean = false;
  onlyNew: boolean = true;
  novedadesPeriodos: NovedadesPeriodo[];
  buscando: boolean;
  cortarRegistro: boolean = false;

  ingreso: any;
  desdeAnterior: boolean = false;
  anteriorRetroactividad: boolean = false;
  novedadesInvalida: boolean = false;

  public cargaCompleta: boolean = false;

  @ViewChild('ChildNovedadPeriodoDetalle') novedadPeriodoDetalle: NovedadesPeriodoDetalleComponent;

  constructor(private novedadesPeriodoService: NovedadesPeriodoService, 
              private dialog: MatDialog, 
              private erroresService: ErroresService, 
              private snackBar: MatSnackBar, 
              private gruposLiquidacionService: GruposLiquidacionService,
              private momentService: MomentSetService) { }

  ngOnInit(): void
  {
    this.obtenerNovedades(false);

    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Editar Novedades Periodo")) this.permisoEdicion = true;
  }

  obtenerNovedades(agrupar)
  {
    this.buscando = true;
    this.novedadesPeriodoService.getByPersonal(this.personalId, agrupar).subscribe(
      data =>
      {
        data.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });

        this.novedadesPeriodos = data;
        this.buscando = false;
        this.cargaCompleta = true;
      },
      error =>
      {
        this.cargaCompleta = true;
        this.buscando = false;
        console.log(error);
      });
  }

  ngOnChanges(changes: SimpleChanges): void
  {
    //throw new Error("Method not implemented.");
  }

  async OnVisualizarDetalle(novedadPeriodo)
  {
    if (novedadPeriodo.id != 0)
    {
      this.obtenerHistorial(novedadPeriodo);
    }
    else
    {
      if (await this.verEstadoNomina())
      {
        this.verDetalle = true;
        this.novedadPeriodo = novedadPeriodo;
        this.habilitarEdicion();
      }
    }
  }

  async OnDeleteChange(event)
  {
    if (await this.validarEdicion(this.novedadPeriodo))
    {
      this.MensajeError = "";
      let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
        width: '400px',
      });

      dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";

      dialogRef.afterClosed().subscribe(result =>
      {
        if (result != null && result)
        {
          let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
            width: '400px'
          });
          dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";

          this.novedadesPeriodoService.eliminar(this.novedadPeriodo.id).subscribe(
            response =>
            {
              this.snackBar.open("Eliminado correctamente.", "OK", { duration: 10000 });
              setTimeout(function ()
              {
                dialogProcesandoRef.close();
              });

              let novedadPeriodo = this.novedadesPeriodosList.filter(d => d.id != this.novedadPeriodo.id)[0];
              if (novedadPeriodo == undefined)
              {
                this.volverAtras();
              }

              this.obtenerHistorial(novedadPeriodo);
            },
            error =>
            {
              if (error.status == 400)
              {
              }
              else
              {
                this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
              }
              dialogProcesandoRef.close();
            });
        }
      });
    }
  }

  OnBackChange()
  {
    this.volverAtras();
  }

  async OnEditChange()
  {
    if (await this.validarEdicion(this.novedadPeriodo))
    {
      this.habilitarEdicion();
      var $this = this;
      setTimeout(function ()
      {
        $this.novedadPeriodoDetalle.form.controls['desde'].disable();
        $this.novedadPeriodoDetalle.form.controls['hasta'].disable();
      });
    }
  }

  OnPeriodChange(index: number)
  {
    let novedad = this.novedadesPeriodosList.find(d => d.id == index);
    this.novedadPeriodo = novedad;
    this.MensajeError = "";
  }

  OnCancelChange(e: boolean)
  {
    this.novedadPeriodoDetalle.setearForm(this.novedadPeriodo);
    this.deshabilitarEdicion();
  }

  OnSaveChange(e: boolean)
  {
    if (this.validarDatos())
    {
      let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
        width: '400px'
      });
      dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

      let formulario = this.novedadPeriodoDetalle.form.getRawValue();

      let datosNov: NovedadesPeriodo = {
        id: formulario.id,
        personal: formulario.personal,
        desde: this.momentService.saveDateServer(formulario.desde, false),
        hasta: this.momentService.saveDateServer(formulario.hasta, false),
        motivo: formulario.motivo,
        unidadMedida: formulario.unidadMedida,
        cantidad: formulario.cantidad,
        importe: formulario.importe,
        moneda: formulario.moneda,
        codigoNomina: formulario.codigoNomina
      };

      this.novedadesPeriodoService.guardar(datosNov, this.cortarRegistro).subscribe(
        novedadPeriodo =>
        {
          novedadPeriodo.desde = this.momentService.convertDateServer(novedadPeriodo.desde);
          novedadPeriodo.hasta = this.momentService.convertDateServer(novedadPeriodo.hasta);

          setTimeout(function ()
          {
            dialogProcesandoRef.close();
          });

          this.snackBar.open("Novedad guardada", "OK", { duration: 10000 });

          this.deshabilitarEdicion();

          this.obtenerHistorial(novedadPeriodo);
          //TODO. Modificar la forma de obtener la fecha sin el TimeZone
          //novedadPeriodo.desde = novedadPeriodo.desde.replace('Z', '');
          this.novedadPeriodoDetalle.setearForm(novedadPeriodo);
        },
        error =>
        {
          dialogProcesandoRef.close();

          if (error.status == 400)
          {
            this.MensajeError = this.erroresService.MostrarError400(error);
          }
          else
          {
            this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
          }
        });
    }
  }

  async OnNewChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.habilitarEdicion();
      this.novedadPeriodoDetalle.form.controls['id'].setValue(0);
      this.novedadPeriodoDetalle.form.controls['hasta'].setValue(new Date("2999-12-31T23:59:59"));
    }
  }

  async OnCutChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.cortarRegistro = true;
      this.habilitarEdicion();

      var $this = this;
      setTimeout(function ()
      {
        $this.novedadPeriodoDetalle.form.controls['hasta'].disable();
      });
    }
  }

  private deshabilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = true;
    this.isEditing = false;
    this.habilitarFormDetalle = false;
    this.cortarRegistro = false;
  }

  private habilitarEdicion()
  {
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    this.MensajeError = "";
    this.disabledEditing = false;
    this.isEditing = true;
    this.habilitarFormDetalle = true;
  }

  private volverAtras()
  {
    this.MensajeError = "";
    this.novedadesPeriodosHistoryList = [];
    this.novedadesPeriodosList = [];
    this.habilitarFormDetalle = false;
    this.verDetalle = false;
    this.obtenerNovedades(false);
  }

  private obtenerHistorial(novedadPeriodo: NovedadesPeriodo)
  {
    this.novedadesPeriodoService.getHistoryByClase(novedadPeriodo.personal, novedadPeriodo.codigoNomina).subscribe(
      novedadesPeriodos =>
      {
        novedadesPeriodos.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });

        this.novedadesPeriodosHistoryList = [];
        novedadesPeriodos.forEach(d =>
        {
          let item = new IboxtoolsItem(d);
          this.novedadesPeriodosHistoryList.push(item);
        });

        this.novedadesPeriodosList = novedadesPeriodos;
        this.verDetalle = true;
        this.novedadPeriodo = novedadPeriodo;
      },
      error =>
      {
        console.log(error);
      });
  }

  private validarDatos(): boolean
  {
    this.MensajeError = "";

    //TODO. Revisar
    if (this.novedadPeriodoDetalle.form.get("moneda").value == 0)
    {
      this.novedadPeriodoDetalle.form.get("moneda").setErrors({ 'invalid': true });
    }

    if (this.novedadPeriodoDetalle.form.get("codigoNomina").value == 0)
    {
      this.novedadPeriodoDetalle.form.get("codigoNomina").setErrors({ 'invalid': true });
    }

    this.ingreso = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
    let desde = this.novedadPeriodoDetalle.form.get("desde").value.toDateString();
    let hasta = this.novedadPeriodoDetalle.form.get("hasta").value.toDateString();
    let hoy = new Date()

    let fingreso = new Date(this.ingreso.desde).toDateString();
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    if (Date.parse(desde) < Date.parse(fingreso))
    {
      this.desdeAnterior = true;
      this.novedadPeriodoDetalle.form.get("desde").setErrors({'desdeAnterior': true });
    } else {
      //valida que la fecha desde no sea anterior a la fecha de retroactividad del grupo de liquidacion vigente
      if (this.gruposLiquidaciones.periodoRetroactividad != null)
      {
        let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
        if (Date.parse(desde) < Date.parse(fretro) )
        {
          this.anteriorRetroactividad = true;
          this.novedadPeriodoDetalle.form.get("desde").setErrors({'anteriorRetroactividad': true });
        }
      }
    }

    if (this.novedadPeriodoDetalle.form.valid)
    {
      return true;
    }
    else
    {
      this.novedadPeriodoDetalle.form.markAllAsTouched();
      return false;
    }
  }

  private async verEstadoNomina() : Promise<boolean>
  {
    let estadoValido = true;
    this.gruposLiquidaciones = await this.gruposLiquidacionService.GetVigenteByPersonal(this.personalId).toPromise();
    if (this.gruposLiquidaciones.estadoActual == 1) {
      estadoValido = false;
      this.snackBar.open("Acción no válida durante el Cálculo de la Nómina. Actualice el registro de gestión.", "OK", { duration: 10000 });
    }
    return estadoValido;
  }

  private validacionRetro(desde) : boolean
  {
    let anterior = false;
    
    if (this.gruposLiquidaciones.periodoRetroactividad != null)
    {
      let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
      if (Date.parse(desde) < Date.parse(fretro) )
      {
        anterior = true;
        this.snackBar.open("Acción no válida porque es anterior al límite de retroactividad.", "OK");
      }
    }
    return anterior;
  }

  private async validarEdicion(row) : Promise<boolean>
  {
    let edita = true;
    
    let estadoValido = await this.verEstadoNomina();
    if (estadoValido == false) edita = false;
    
    if(edita)
    {
      let anterior = this.validacionRetro(row.desde);
      if(anterior) edita = false;  
    }
    return edita;
  }
  
}
